import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-up-right', 'ChevronUpRight', [["path",{"d":"M8 8h8v8","key":"svg-0"}]]);